import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as fromContainers from './containers';
import * as fromComponents from './components';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { UIModule } from 'libraries/ui/ui.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { SharedModule } from '../shared/components/shared.module';
import { HotelService } from 'libraries/hotel/services/hotel.service';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { BookingService } from 'libraries/hotel/services/booking.service';
import { SharedData } from 'libraries/hotel/shared-data';
import { QuotationPageResolver } from './quotation-page.resolver';
import { ROUTES } from './routes';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { HotelResumeModule } from 'libraries/hotel/components/hotel-resume/hotel-resume.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { HotelResumeSearchModule } from 'libraries/hotel/components/hotel-resume-search/hotel-resume-search.module';
import { RoomModule } from 'libraries/hotel/components/room/room.module';
import { DescriptionModule } from 'libraries/hotel/components/description/description.module';
import { InformationsModule } from 'libraries/hotel/components/informations/informations.module';
import { HotelCurrencyModule } from 'libraries/service/hotel-currency/hotel-currency.module';
import { ConfigSharedHotelResolver } from 'libraries/hotel/resolvers/config-shared-hotel.resolver';
import { TravellerFormModule } from 'libraries/module/formbuilder/forms/travellerForm/travellerForm.module';
import { PipesModule } from 'libraries/pipes/pipes.module';
import { ConfigSharedHotelModule } from "libraries/service/resources/configuration/config-shared-hotel.module";
import { HotelResourceModule } from 'libraries/service/resources/hotel/hotelResource.module';
import { RoomServiceModule } from 'libraries/hotel/services/room/room-service.module';
import { ConfigurationResourceModule } from 'libraries/service/resources/configuration/configurationResource.module';
import { MapModule } from 'libraries/map/map.module';
import { MenuDetailsModule } from 'libraries/hotel/components/menu-details/menu-details.module';
import { ModalModule } from "libraries/ui_modal/Modal.module";
import { NotepadModule } from "libraries/component/notepad/notepad.module";
import { BookingRemarksModule } from "libraries/component/booking-information/components/booking-remarks/booking-remarks.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { SectorStayDetailsModule } from "libraries/component/booking-information/components/sectors/components/sectors-stay/sector-stay-details/sector-stay-details.module";
import { QuotationToBookingMappingModule } from "libraries/service/quotation-to-booking-service/quotation-to-booking-mapping.module";
import { EmergencyContactModule } from './components/emergency-contact/emergency-contact.module';
import { TextModule } from 'libraries/module/formbuilder/fields/text/text.module';
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";
import { DateParserModule } from 'libraries/service/date/dateParser.module';
import {
    TermsOfUseModule
} from "libraries/component/terms-of-use/terms-of-use.module";
import { UrlHelperModule } from "libraries/service/url-helper/url-helper.module";
import { CheckNoteModule } from "libraries/component/check-note/check-note.module";
import {LocalizedModule} from "../../libraries/pipes/localized/localized.module";

@NgModule({
    imports: [
        BookingRemarksModule,
        CardModule,
        CheckNoteModule,
        CommonModule,
        ConfigSharedHotelModule,
        ConfigurationResourceModule,
        DatePipeModule,
        DescriptionModule,
        EmergencyContactModule,
        FormsModule,
        HotelCurrencyModule,
        HotelResourceModule,
        HotelResumeModule,
        HotelResumeSearchModule,
        InformationsModule,
        LoaderModule,
        MapModule,
        MenuDetailsModule,
        ModalModule,
        NotepadModule,
        NotificationModule,
        PermissionModule,
        PipesModule,
        QuotationToBookingMappingModule,
        RoomModule,
        RoomServiceModule,
        RouterModule.forChild(ROUTES),
        SectorStayDetailsModule,
        SharedModule,
        TextModule,
        TravellerFormModule,
        UIModule,
        CheckboxFieldModule,
        DateParserModule,
        TermsOfUseModule,
        UrlHelperModule,
        LocalizedModule,
    ],
    declarations: [
        ...fromContainers.containers,
        ...fromComponents.components,
    ],
    exports: [
        ...fromContainers.containers,
        ...fromComponents.components,
    ],
    providers: [
        HotelService,
        HelperService,
        BookingService,
        SharedData,
        QuotationPageResolver,
        ConfigSharedHotelResolver,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class QuotationPageModule { }
